<div
  class="t-tree-banner card flex justify-content-center h-full"
  *ngIf="!noPermission; else noPermissionTemplate"
>
  <p-tree
    class="w-full md:w-30rem"
    styleClass="bg-transparent"
    expanded="true"
    [value]="treeNodes"
    [selectionMode]="selectionMode"
    [(selection)]="selectedNode"
  >
    <ng-template let-node pTemplate="default">
      <div class="{{ node.code }}" (click)="onNodeSelect(node)">
        {{ node.label }}
      </div>
    </ng-template>
  </p-tree>
</div>
<ng-template #noPermissionTemplate>
  <div class="t-tree-banner card flex justify-content-center h-full">
    <p>{{ 'common.component.no_permission_access' | translate }}</p>
  </div>
</ng-template>
